import React, { Component } from "react";
import { List, Button, Modal, Input, Row, Col, Select } from "antd";
import { withRouter } from "react-router-dom";
import Axios from "../../../config/axios";
import "../../../style.css";
import "./style.css";
import withErrorHandler from "../../../hoc/withErrorHandler";
import Loading from "../../../components/Loading";
import openNotificationWithIcon from "helpers/notification";

class AddLetter extends Component {
  state = {
    letterheads: [],
    searchedLetterheads: [],
    selectedLetterhead: {},
    visibleModal: false,
    file: {},
    addModal: false,
    units: [],
    selectedUnit: "",
  };

  componentDidMount() {
    this.fetchLetter();
    this.fetchUnits();
  }

  fetchUnits = async () => {
    const response = await Axios.get("/units");

    const units = [];
    response.data.payload[0].children.forEach((unit) => {
      if (unit.type === "Fakultas") {
        units.push(unit);
        if (unit.children) {
          unit.children.forEach((child) => {
            units.push(child);
          });
        }
      }
    });
    this.setState({ units });
  };

  fetchLetter = () => {
    Axios.get("/letterhead").then(async (response) => {
      const letterheads = response.data.payload.map(async (letter) => {
        const unit = await Axios.get("/units?unit_id=" + letter.unit_id);
        return {
          ...letter,
          unit_name: unit.data.payload.name,
          level: unit.data.payload.level,
        };
      });

      const result = await Promise.all(letterheads);
      this.setState({ letterheads: result, searchedLetterheads: result });
    });
  };

  handleShowModal = (letterhead) => {
    this.setState({ selectedLetterhead: letterhead, visibleModal: true });
  };

  hideModal = () => {
    this.setState({ visibleModal: false, selectedLetterhead: {} });
  };

  handleShowAddModal = () => {
    this.setState({ addModal: true });
  };

  hideAddModal = () => {
    this.setState({ addModal: false });
  };

  handleSearch = (val) => {
    const temp = this.state.searchedLetterheads.filter((letter) =>
      letter.unit_name.toLowerCase().includes(val.toLowerCase())
    );
    this.setState({ letterheads: temp });
  };

  handleChageFile = (e) => {
    this.setState({ file: e.target.files[0] });
  };

  handleSave = () => {
    const { selectedLetterhead } = this.state;
    var formData = new FormData();
    formData.append(
      "unit_id",
      selectedLetterhead.unit_id ?? this.state.selectedUnit
    );
    formData.append("file", this.state.file);
    Axios.request({
      method: selectedLetterhead._id ? "PUT" : "POST",
      data: formData,
      url:
        "/letterhead/save" +
        (selectedLetterhead._id ? "/" + selectedLetterhead._id : ""),
    }).then(() => {
      // window.location.reload()
      this.hideModal();
      this.hideAddModal();
      this.fetchLetter();
      openNotificationWithIcon(
        "success",
        "Kop Surat",
        "Kop Surat berhasil diupdate."
      );
    });
  };

  handleSelect = (e) => {
    this.setState({ selectedUnit: e });
  };

  render() {
    return (
      <>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Input.Search onSearch={this.handleSearch} placeholder="Search" />
          </Col>
          <Col>
            <Button type="primary" onClick={this.handleShowAddModal}>
              Tambah
            </Button>
          </Col>
        </Row>

        <List
          size="large"
          dataSource={this.state.letterheads || []}
          renderItem={(item) => (
            <List.Item>
              <Button
                type="link"
                href={`/admin/pengaturan?unit_id=${item.unit_id}`}
              >
                {item.unit_name} - {item.level}
              </Button>
            </List.Item>
          )}
        />

        <Modal
          visible={this.state.visibleModal}
          footer={null}
          onCancel={this.hideModal}
          title="Kop Surat"
        >
          <img
            src={this.state.selectedLetterhead.file}
            alt="kop surat"
            style={{ width: "100%" }}
          />
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <input
                type="file"
                name="kop_surat"
                onChange={this.handleChageFile}
              />
            </Col>
            <Col span={24}>
              <Button
                type="primary"
                onClick={this.handleSave}
                style={{ width: "100%" }}
              >
                Upload
              </Button>
            </Col>
          </Row>
        </Modal>

        <Modal
          visible={this.state.addModal}
          footer={null}
          onCancel={this.hideAddModal}
          title="Tambah Kop Surat"
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Select
                placeholder="Unit"
                style={{ width: "100%" }}
                onChange={this.handleSelect}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                showSearch
              >
                {this.state.units.map((unit) => (
                  <Select.Option value={unit.id} key={unit.id}>
                    {unit.name} - {unit.level}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col span={24}>
              <input
                type="file"
                name="kop_surat"
                onChange={this.handleChageFile}
              />
            </Col>
            <Col span={24}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={this.handleSave}
              >
                Simpan
              </Button>
            </Col>
          </Row>
        </Modal>
        <Loading loading={this.props.loading} />
      </>
    );
  }
}

export default withRouter(withErrorHandler(AddLetter, Axios));
